import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class BcLogsProvider extends HttpRequest {
  getBcLogs (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/bc-logs', query)
  }
}
